import type { IconNode } from '../types';

/**
 * @name text-wrap
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTYgMTYtMyAzIDMgMyIgLz4KICA8cGF0aCBkPSJNMyAxMmgxNC41YTEgMSAwIDAgMSAwIDdIMTMiIC8+CiAgPHBhdGggZD0iTTMgMTloNiIgLz4KICA8cGF0aCBkPSJNMyA1aDE4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/text-wrap
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const TextWrap: IconNode = [
  ['path', { d: 'm16 16-3 3 3 3' }],
  ['path', { d: 'M3 12h14.5a1 1 0 0 1 0 7H13' }],
  ['path', { d: 'M3 19h6' }],
  ['path', { d: 'M3 5h18' }],
];

export default TextWrap;
